import React, { useEffect, useRef, useState } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { apiErrorMessage } from "../../helper/apiError";
import {
  FORM_DATE_TIME_FORMAT,
  reminderDateToFormValue,
} from "../../helper/reminderDate";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  FormGroup,
  Grid,
  IconButton,
  InputLabel,
  TextField,
  Typography,
  createSvgIcon,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import OutlinedTextAreaField from "../../component/inputfiled/OutlinedTextedArea";
import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import MyDatePicker from "../../component/datepicker/OutlinedDatepicker";
import dayjs from "dayjs";
import RemoveIcon from "@mui/icons-material/Remove";
import CustomButton from "../../component/button/button";
import Previews from "../../component/dropzone/Mydropzone";
import Mylogodropzone from "../../component/dropzone/Mylogodropzone";
import { MenuItem, Select, Checkbox, ListItemText } from "@mui/material";
import CustomSelect from "../../component/select field/OutlinedSelectField";
import OnlyDatePicker from "../../component/datepicker/MyDatepicker";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  GetCountryAction,
  GetProgramAction,
  GetRoleAction,
  GetUniversityAction,
} from "../../Redux/action/SettingAction";
import {
  CreateOrganizationService,
  EditOrganizationService,
  CheckEmailExistService,
} from "../../Redux/service/SettingService";
import moment from "moment";
import { orgvalidationSchema } from "./ValidationConstant";
import { GetDegreeAction } from "../../Redux/action/ApplicationAction";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ExpandMore } from "@mui/icons-material";
import MultiSelect from "../../component/select field/MultiSelectWithAllOption";

const icon = createSvgIcon(
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 4.5L6 7.5L3 4.5"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const selectOptions = [
  { value: 10, label: "Option 1" },
  { value: 20, label: "Option 2" },
  { value: 30, label: "Option 3" },
];
const CreateOrganizationPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formikRef = useRef(null);
  const childRef = useRef(null);
  const datetimepickerRef = useRef(null);
  const [selectedUnis, setSelectedUnis] = React.useState([]);
  const { id } = useParams();

  const [Edit, setEdit] = useState(id ? true : false);

  const [prefieldData, setPrefieldData] = useState();

  const [reminders, setReminders] = useState([]);

  const [ownerPerson, setOwnerPerson] = useState([]);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [Countrylist, setCountrylist] = useState([]);

  const [statelist, setStatelist] = useState([]);

  const [TaxDetailsOption, setTaxDetailsOption] = useState(false);
  const [Universitylist, setUniversitylist] = useState([]);

  const [formLoading, setFormLoading] = useState(false);

  const [Rolelist, setRolelist] = useState([]);

  const [univEditdetail, setUnivEditdetail] = useState([]);

  const [Programlist, setProgramlist] = useState([]);

  const [Degreelist, setDegreelist] = useState([]);

  // Country codes for phone picker
  const countryCodes = [
    { code: "+1", country: "USA/Canada" },
    { code: "+44", country: "UK" },
    { code: "+91", country: "India" },
    { code: "+61", country: "Australia" },
    { code: "+86", country: "China" },
    { code: "+81", country: "Japan" },
    { code: "+49", country: "Germany" },
    { code: "+33", country: "France" },
    { code: "+39", country: "Italy" },
    { code: "+34", country: "Spain" },
    { code: "+7", country: "Russia" },
    { code: "+55", country: "Brazil" },
    { code: "+52", country: "Mexico" },
    { code: "+971", country: "UAE" },
    { code: "+65", country: "Singapore" },
  ];

  // Helper function to parse phone number and extract country code
  const parsePhoneNumber = (phone) => {
    if (!phone) return { countryCode: "+91", number: "" };

    const phoneStr = String(phone);
    // Check if phone starts with +
    if (phoneStr.startsWith("+")) {
      // Find matching country code
      for (const cc of countryCodes) {
        if (phoneStr.startsWith(cc.code)) {
          return {
            countryCode: cc.code,
            number: phoneStr.substring(cc.code.length),
          };
        }
      }
    }
    // Default if no country code found
    return { countryCode: "+1", number: phoneStr };
  };

  // Helper function to merge country code and phone number
  const mergePhoneNumber = (countryCode, number) => {
    return countryCode + number;
  };

  const DegreelistState = useSelector(
    (state) => state.application?.degree?.data?.degrees
  );

  const CountrylistState = useSelector(
    (state) => state.setting?.countryCount?.data?.data
  );

  useEffect(() => {
    // console.log(CountrylistState)
    setCountrylist(
      CountrylistState?.map(({ country, ...rest }) => ({
        title: country,
        _id: country,
        ...rest,
      }))
    );
  }, [CountrylistState]);

  useEffect(() => {
    dispatch(GetCountryAction());

    dispatch(GetDegreeAction());
  }, []);

  useEffect(() => {
    setDegreelist(
      DegreelistState?.map(({ name, ...rest }) => ({
        title: name,
        ...rest,
      }))
    );
  }, [DegreelistState]);

  const EditOrganzitiondataState = useSelector(
    (state) => state.setting?.organization?.data?.organizations
  );

  useEffect(() => {
    let data = {
      page: 1,
      limit: 0,
      light: true,
    };
    dispatch(GetUniversityAction(data));
  }, []);

  const UniversitylistState = useSelector(
    (state) => state.setting?.university?.data?.universities
  );

  useEffect(() => {
    dispatch(GetRoleAction());
    dispatch(GetProgramAction());
  }, []);

  const RolelistState = useSelector(
    (state) => state.setting?.role?.data?.roles
  );

  useEffect(() => {
    setRolelist(RolelistState);
  }, [RolelistState]);

  const ProgramlistState = useSelector(
    (state) => state.setting?.program?.data?.programs
  );

  useEffect(() => {
    const updatedData = ProgramlistState?.map(({ program, ...rest }) => ({
      title: program,
      ...rest,
    }));
    setProgramlist(updatedData);
  }, [ProgramlistState]);

  useEffect(() => {
    setPrefieldData(
      EditOrganzitiondataState?.filter((data) => data._id === id)?.[0]
    );
    setTaxDetailsOption(
      EditOrganzitiondataState?.filter((data) => data._id === id)?.[0]
        ?.textDetails
    );
    setReminders(
      EditOrganzitiondataState?.filter(
        (data) => data._id === id
      )?.[0]?.reminders?.map((data) => {
        let json = {
          _id: data._id,
          text: data.text,
          // A reminder that was never given a resend date comes back as null;
          // moment.unix(null) is the epoch, not "empty".
          reminderDateTime: reminderDateToFormValue(data.reminderDateTime),
          resendDateTime: reminderDateToFormValue(data.resendDateTime),
          isNew: false,
        };
        return json;
      })
    );
    setOwnerPerson(
      EditOrganzitiondataState?.filter(
        (data) => data._id === id
      )?.[0]?.owners?.map((data) => {
        let json = {
          ownerName: data.firstName,
          email: data.email,
          phone: data.phone,
          role: Edit ? data.role?._id : "",
        };
        return json;
      })
    );
    const sortedEditUnis = EditOrganzitiondataState?.filter(
      (data) => data._id === id
    )?.[0]?.universities?.map((data) => ({
      university: data?.university?._id,
      universityName: data?.university?.name || "",
      commissionAndPrograms: data.commissionAndPrograms.map((comm) => ({
        degree: comm.degree?._id,
        program: comm.program.map((data) => {
          return data._id;
        }),
        commissionType: comm.commissionType,
        value: comm.value,
        duration: comm.duration,
        customValue: comm.customValue,
        paymentCycle: comm.paymentCycle,
        customAgentCommission: comm.customAgentCommission,
        termsAndCondition: comm.termsAndCondition,
        description: comm.description,
        agentCommission: comm.agentCommission,
      })),
    })) || [];
    sortedEditUnis.sort((a, b) => (a.universityName || "").localeCompare(b.universityName || ""));
    setUnivEditdetail(sortedEditUnis);
    setSelectedUnis(sortedEditUnis.map((data) => data.university));
    // console.log(
    //   EditOrganzitiondataState?.filter(
    //     (data) => data._id === id
    //   )?.[0]?.universities?.map((data) => data?.university?._id)
    // );
  }, [Edit, EditOrganzitiondataState, id]);

  const handleFormSubmit = async (values, formType) => {
    // //(values, formType, formikRef.current);
    setFormLoading(true);

    if (!Edit) {
      // Owner-email existence is checked only here, at creation time —
      // not on every keystroke via the validation schema
      for (let i = 0; i < (values.owners?.length || 0); i++) {
        const email = values.owners[i]?.email;
        if (!email) continue;
        try {
          const res = await CheckEmailExistService(email);
          if (res?.data?.exists) {
            setFormLoading(false);
            formikRef.current?.setFieldError(
              `owners[${i}].email`,
              "User already exists with this email id"
            );
            dispatch(
              showSnackbar(
                `User already exists with this email id: ${email}`,
                "error"
              )
            );
            return;
          }
        } catch (err) {
          console.error("Email check failed:", err);
        }
      }

      await CreateOrganizationService(values)
        .then((res) => {
          if (res.status === 200) {
            //(res);
            setFormLoading(false);

            dispatch(showSnackbar(res.data.message, "success"));
            if (formType === "reset") {
              formikRef.current.resetForm();
            } else {
              navigate("/CAE/OrganizationList");
            }
          }
        })
        .catch((e) => {
          setFormLoading(false);
          // formikRef.current.resetForm();
          dispatch(showSnackbar(apiErrorMessage(e), "error"));
        });
    } else {
      //(values, "edit values");
      values["organizationId"] = id;
      await EditOrganizationService(values)
        .then((res) => {
          if (res.status === 200) {
            //(res);
            setFormLoading(false);

            dispatch(showSnackbar(res.data.message, "success"));
            if (formType === "reset") {
              formikRef.current.resetForm();
            } else {
              navigate("/CAE/OrganizationList");
            }
          }
        })
        .catch((e) => {
          setFormLoading(false);
          // formikRef.current.resetForm();
          dispatch(showSnackbar(apiErrorMessage(e), "error"));
        });
    }
  };

  useEffect(() => {
    if (UniversitylistState) {
      //(UniversitylistState, "univ state");

      const updatedData = UniversitylistState?.map(({ name, ...rest }) => ({
        title: name,
        ...rest,
      })).sort((a, b) => (a.title || "").localeCompare(b.title || ""));
      setUniversitylist(updatedData);
    }
  }, [UniversitylistState]);

  if (!prefieldData && Edit) {
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <CircularProgress color="inherit" />
      </div>
    ); // You can replace this with a loading spinner
  }

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        organizationName: Edit ? prefieldData.organizationName : "",
        country: Edit ? prefieldData?.country : "INDIA",
        state: Edit ? prefieldData?.state : "",
        city: Edit ? prefieldData?.city : "",
        additionalOrganizationName: Edit
          ? prefieldData.additionalOrganizationName
          : "",
        textDetails: Edit ? prefieldData.textDetails : false,
        gstName: Edit ? prefieldData.gstName : "",
        gstNumber: Edit ? prefieldData.gstNumber : "",
        address: Edit ? prefieldData.address : "",
        notes: Edit ? prefieldData.notes?.[0]?.text : "",
        documents: Edit ? prefieldData.documents : [],
        startContractDate: Edit ? prefieldData.startContractDate : null,
        endContractDate: Edit ? prefieldData.endContractDate : null,
        reminders: Edit
          ? reminders
          : [
            {
              reminderDateTime: null,
              text: "",
              resendDateTime: null,
              isNew: true,
            },
          ],
        universities: Edit
          ? univEditdetail
          : [],
        owners: Edit
          ? ownerPerson
          : [
            {
              ownerName: "",
              email: "",
              phone: "",
              role: "",
            },
          ],
      }}
      validationSchema={orgvalidationSchema}
      onSubmit={(values) => {
        console.log(values, "payload of org");
        if (values?.reminders?.[0]?.reminderDateTime === null) {
          delete values["reminders"];
        }
        handleFormSubmit(values, "submit");
      }}
    >
      {({
        values,
        errors,
        handleBlur,
        handleChange,
        touched,
        handleSubmit,
        setFieldValue,
        resetForm,
        setFieldError,
      }) => (
        <Form className="" onSubmit={handleSubmit}>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item lg={6} xs={12}>
              <div className="d-flex align-items-center">
                <IconButton onClick={() => navigate(-1)}>
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h2.small}
                >
                  Settings
                </Typography>
                <Typography
                  className="px-2 pt-1"
                  fontFamily={FontFamily.Poppins}
                  fontSize={fontSize.h4.medium}
                  fontWeight={fontWeight.W300}
                  color={ThemeColor.GREY}
                >
                  {!Edit ? "Create" : "Edit"} Organization
                </Typography>
              </div>
            </Grid>
            <Grid item lg={6} xs={12}>
              {(window.sessionStorage.getItem("user_role_type") === "admin" ||
                window.sessionStorage.getItem("user_role_type") === "user" ||
                (window.sessionStorage.getItem("user_role_type") === "agent" &&
                  window.sessionStorage.getItem("role") === "admin")) && (
                <div className="d-flex justify-content-end align-items-center gap-2 w-100">
                  <CustomButton
                    variant="contained"
                    type="submit"
                    backgroundColor={ThemeColor.PURPLE}
                    color={ThemeColor.WHITE}
                    loading={formLoading}
                  >
                    {!Edit ? "Save Organization" : "Save Changes"}
                  </CustomButton>
                  {Edit ? (
                    <CustomButton
                      variant="contained"
                      type="button"
                      backgroundColor={ThemeColor.RED}
                      color={ThemeColor.WHITE}
                      loading={formLoading}
                      onClick={() => {
                        if (childRef.current) {
                          childRef.current.someFunction(
                            prefieldData?.documents
                          );
                        }
                        resetForm();
                      }}
                    >
                      Cancel Changes
                    </CustomButton>
                  ) : (
                    <CustomButton
                      variant="contained"
                      type="button"
                      backgroundColor={ThemeColor.PURPLE}
                      color={ThemeColor.WHITE}
                      loading={formLoading}
                      onClick={async () => {
                        // run the same validation as the normal submit —
                        // this button doesn't go through Formik's onSubmit
                        const validationErrors =
                          await formikRef.current.validateForm();
                        if (Object.keys(validationErrors).length > 0) {
                          dispatch(
                            showSnackbar(
                              "Please fill all required fields before saving",
                              "error"
                            )
                          );
                          return;
                        }
                        handleFormSubmit(values, "reset");
                      }}
                    >
                      Add Another
                    </CustomButton>
                  )}
                </div>
              )}
            </Grid>
          </Grid>
          <div className="container">
            <Grid container spacing={2}>
                {/* grid for right basic content */}
                <Grid item lg={8}>
                  <Typography
                    align="center"
                    fontFamily={FontFamily.Poppins}
                    fontWeight={fontWeight.W600}
                    fontSize={fontSize.h3.medium}
                    color={ThemeColor.PURPLE}
                  >
                    {!Edit ? "Create New" : "Edit"} Organization
                  </Typography>
                  <Grid container spacing={2} className="mt-4">
                    {/* <NoPaddingGridItem item lg={2} md={2} sm={12} xs={12}>
                      <div className="agent-logo">
                        <img
                          src="/assest/dropzonelogo.png"
                          className="w-100 h-100"
                          alt="agentlogo"
                        ></img>
                      </div>
                    </NoPaddingGridItem> */}
                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            Name Of The Organization *
                          </Typography>
                          <OutlinedInputField
                            disable={Edit ? true : false}
                            value={values.organizationName}
                            name={"organizationName"}
                            onChange={handleChange}
                            placeholder="Enter name of organization"
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.organizationName}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>

                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            Secondary Name Of The Organization
                          </Typography>
                          <OutlinedInputField
                            value={values.additionalOrganizationName}
                            name={"additionalOrganizationName"}
                            onChange={handleChange}
                            placeholder="Enter name of organization"
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.additionalOrganizationName}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>

                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            Country *
                          </Typography>
                          <CustomSelect
                            value={Countrylist && values?.country}
                            name={"country"}
                            multiple={false}
                            option={Countrylist}
                            onChange={(e) => {
                              setFieldValue("country", e.target.value);
                              // dispatch(GetStateListAction(e.target.value))
                            }}
                            label={"Country"}
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.country}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>
                    <NoPaddingGridItem item lg={6} md={6} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            State *
                          </Typography>
                          <CustomSelect
                            value={Countrylist && values?.state}
                            name={"state"}
                            multiple={false}
                            option={
                              Countrylist &&
                              values.country &&
                              Countrylist?.filter(
                                (data) => data.title === values.country
                              )?.[0]?.states?.map((state) => ({
                                title: state,
                                _id: state,
                              }))
                            }
                            onChange={(e) => {
                              setFieldValue("state", e.target.value);
                            }}
                            label={"State"}
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.state}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>
                    <NoPaddingGridItem item lg={6} md={6} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            City *
                          </Typography>
                          <OutlinedInputField
                            value={values.city}
                            name={"city"}
                            onChange={handleChange}
                            placeholder="Enter your details...."
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.city}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>

                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="mt-3">
                          <CustomSelect
                            value={values?.textDetails}
                            name={"textDetails"}
                            multiple={false}
                            option={[
                              { _id: true, title: "Yes" },
                              { _id: false, title: "No" },
                            ]}
                            onChange={(e) => {
                              setTaxDetailsOption(e.target.value);
                              setFieldValue("textDetails", e.target.value);
                            }}
                            label={"GST Registered"}
                            fullWidth={true}
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>
                    {TaxDetailsOption === true && (
                      <NoPaddingGridItem item lg={6} md={6} sm={12} xs={12}>
                        <FormGroup style={{}}>
                          <div className="">
                            <Typography
                              className="mb-2"
                              fontFamily={FontFamily.Lato}
                              fontSize={fontSize.h3.medium}
                              fontWeight={fontWeight.W400}
                            >
                              GST Number
                            </Typography>
                            <OutlinedInputField
                              value={values.gstNumber}
                              onChange={handleChange}
                              name={"gstNumber"}
                              placeholder="Enter your details"
                              fullWidth={true}
                            />
                          </div>
                        </FormGroup>
                      </NoPaddingGridItem>
                    )}
                    {TaxDetailsOption === true && (
                      <NoPaddingGridItem item lg={6} md={6} sm={12} xs={12}>
                        <FormGroup style={{}}>
                          <div className="">
                            <Typography
                              className="mb-2"
                              sx={{
                                fontWeight: 520,
                                fontSize: "0.9rem",
                                letterSpacing: "0.00938em",
                                fontFamily: "Lato !important",
                              }}
                            >
                              GST Name
                            </Typography>
                            <OutlinedInputField
                              value={values.gstName}
                              onChange={handleChange}
                              name={"gstName"}
                              placeholder="Enter your details...."
                              fullWidth={true}
                            />
                          </div>
                        </FormGroup>
                      </NoPaddingGridItem>
                    )}
                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            Organization Address
                          </Typography>
                          <OutlinedTextAreaField
                            multiline={true}
                            minRows={4}
                            value={values.address}
                            name={"address"}
                            onChange={handleChange}
                            placeholder="Address here"
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.address}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>
                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FieldArray name="reminders">
                        {({ push, remove }) => (
                          <div>
                            {values.reminders?.map((reminder, index) => (
                              <Grid
                                container
                                spacing={2}
                                className="mt-4"
                                key={index}
                              >
                                {index > 0 && (
                                  <NoPaddingGridItem
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="d-flex align-items-center"
                                  >
                                    <div className="w-100 mt-2 mb-3">
                                      <Divider>
                                        <Chip
                                          label={`${index + 1
                                            } Reminder Details `}
                                          size="small"
                                        />
                                      </Divider>
                                    </div>
                                  </NoPaddingGridItem>
                                )}
                                <NoPaddingGridItem
                                  item
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                >
                                  <FormGroup style={{}}>
                                    <div className="">
                                      <Typography
                                        className="mb-2"
                                        sx={{
                                          fontWeight: 520,
                                          fontSize: "0.9rem",
                                          letterSpacing: "0.00938em",
                                          fontFamily: "Lato !important",
                                        }}
                                      >
                                        Reminder Date & Time
                                      </Typography>
                                      <MyDatePicker
                                        ref={datetimepickerRef}
                                        minDate={dayjs().startOf("day")}
                                        // minTime={dayjs().startOf("day")}
                                        label="Enter details..."
                                        // value={dayjs(values.contactPerson[index].reminder_date).toDate()}

                                        value={
                                          values.reminders[index]
                                            ?.reminderDateTime
                                            ? dayjs(
                                              values.reminders[index]
                                                ?.reminderDateTime
                                            ).isValid()
                                              ? dayjs(
                                                values.reminders[index]
                                                  ?.reminderDateTime
                                              )
                                              : null
                                            : null
                                        }
                                        onChange={(date) => {
                                          setFieldValue(
                                            `reminders[${index}].reminderDateTime`,
                                            dayjs(date).format(
                                              FORM_DATE_TIME_FORMAT
                                            )
                                          );
                                        }}
                                        helperText={
                                          <Typography
                                            align="left"
                                            // className="px-3"
                                            color={ThemeColor.RED}
                                            fontSize={fontSize.h4.medium}
                                            fontFamily={FontFamily.Lato}
                                            fontWeight={fontWeight.W500}
                                          >
                                            {
                                              errors.reminders?.[index]
                                                ?.reminderDateTime
                                            }
                                          </Typography>
                                        }
                                      />
                                    </div>
                                  </FormGroup>
                                </NoPaddingGridItem>

                                <NoPaddingGridItem
                                  item
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                >
                                  <FormGroup style={{}}>
                                    <div className="">
                                      <Typography
                                        className="mb-2"
                                        sx={{
                                          fontWeight: 520,
                                          fontSize: "0.9rem",
                                          letterSpacing: "0.00938em",
                                          fontFamily: "Lato !important",
                                        }}
                                      >
                                        Resend Date & Time
                                      </Typography>
                                      <MyDatePicker
                                        ref={datetimepickerRef}
                                        minDate={dayjs().startOf("day")}
                                        label="Enter details..."
                                        // value={dayjs(values.contactPerson[index].reminder_date).toDate()}

                                        value={
                                          values.reminders[index]
                                            ?.resendDateTime
                                            ? dayjs(
                                              values.reminders[index]
                                                ?.resendDateTime
                                            ).isValid()
                                              ? dayjs(
                                                values.reminders[index]
                                                  ?.resendDateTime
                                              )
                                              : null
                                            : null
                                        }
                                        onChange={(date) => {
                                          setFieldValue(
                                            `reminders[${index}].resendDateTime`,
                                            dayjs(date).format(
                                              FORM_DATE_TIME_FORMAT
                                            )
                                          );
                                        }}
                                        helperText={
                                          <Typography
                                            align="left"
                                            // className="px-3"
                                            color={ThemeColor.RED}
                                            fontSize={fontSize.h4.medium}
                                            fontFamily={FontFamily.Lato}
                                            fontWeight={fontWeight.W500}
                                          >
                                            {
                                              errors.reminders?.[index]
                                                ?.resendDateTime
                                            }
                                          </Typography>
                                        }
                                      />
                                    </div>
                                  </FormGroup>
                                </NoPaddingGridItem>

                                <NoPaddingGridItem
                                  item
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                >
                                  <FormGroup style={{}}>
                                    <div className="">
                                      <Typography
                                        className="mb-2"
                                        sx={{
                                          fontWeight: 520,
                                          fontSize: "0.9rem",
                                          letterSpacing: "0.00938em",
                                          fontFamily: "Lato !important",
                                        }}
                                      >
                                        Reminder Note
                                      </Typography>
                                      <OutlinedInputField
                                        value={values.reminders[index].text}
                                        name={`reminders[${index}].text`}
                                        onChange={handleChange}
                                        placeholder="Enter reminder details..."
                                        fullWidth={true}
                                        helperText={
                                          <Typography
                                            align="left"
                                            // className="px-3"
                                            color={ThemeColor.RED}
                                            fontSize={fontSize.h4.medium}
                                            fontFamily={FontFamily.Lato}
                                            fontWeight={fontWeight.W500}
                                          >
                                            {errors.reminders?.[index]?.text}
                                          </Typography>
                                        }
                                      />
                                    </div>
                                  </FormGroup>
                                </NoPaddingGridItem>
                                {index > 0 && (
                                  <NoPaddingGridItem
                                    item
                                    lg={3}
                                    md={3}
                                    sm={12}
                                    xs={12}
                                    className="d-flex align-items-center"
                                  >
                                    <div className="d-flex justify-content-start w-100 mt-3">
                                      <Typography
                                        className="px-2"
                                        fontSize={fontSize.h3.small}
                                        fontFamily={FontFamily.Lato}
                                        color={ThemeColor.BLACK}
                                        fontWeight={fontWeight.W600}
                                      >
                                        Delete Reminder
                                      </Typography>
                                      <IconButton
                                        className="form-icon"
                                        sx={{
                                          background: ThemeColor.RED,
                                          color: ThemeColor.WHITE,
                                        }}
                                        variant="contained"
                                        onClick={() => remove(index)}
                                      >
                                        <RemoveIcon />
                                      </IconButton>
                                    </div>
                                  </NoPaddingGridItem>
                                )}
                              </Grid>
                            ))}
                            <div className="d-flex justify-content-start w-100 mt-2 mb-3">
                              <Typography
                                className="px-2"
                                fontSize={fontSize.h3.small}
                                fontFamily={FontFamily.Lato}
                                color={ThemeColor.BLACK}
                                fontWeight={fontWeight.W600}
                              >
                                Add Another Reminder
                              </Typography>
                              <IconButton
                                className="form-icon"
                                sx={{
                                  background: ThemeColor.BLUE,
                                  color: ThemeColor.WHITE,
                                }}
                                onClick={() =>
                                  push({
                                    text: "",
                                    reminderDateTime: null,
                                    resendDateTime: null,
                                    isNew: true,
                                  })
                                }
                              >
                                <AddIcon />
                              </IconButton>
                            </div>
                          </div>
                        )}
                      </FieldArray>
                    </NoPaddingGridItem>
                  </Grid>
                </Grid>

                {/* grid for left docs uploading content */}
                <Grid item lg={4} xs={12}>
                  <div className="w-100 d-flex justify-content-center mt-4">
                    <Previews
                      deleteShow={true}
                      ref={childRef}
                      mainText={"Supporting Documents"}
                      text="Folder will be auto-created by organization name"
                      initialValue={values?.documents}
                      handleMydropzoneFile={(updatedFiles) => {
                        // //(updatedFiles, "oooyesah");
                        setFieldValue("documents", updatedFiles);
                      }}
                      helperText={
                        <Typography
                          align="left"
                          // className="px-3"
                          color={ThemeColor.RED}
                          fontSize={fontSize.h4.medium}
                          fontFamily={FontFamily.Lato}
                          fontWeight={fontWeight.W500}
                        >
                          {errors.documents}
                        </Typography>
                      }
                    />
                  </div>

                  <FormGroup style={{}}>
                    <div className="mt-4">
                      <OnlyDatePicker
                        views={["year", "month", "day"]}
                        label="Start Contract Date"
                        // value={startDate}
                        value={
                          values.startContractDate
                            ? dayjs(values.startContractDate).isValid()
                              ? dayjs(values.startContractDate)
                              : null
                            : null
                        }
                        onChange={(date) => {
                          setStartDate(date);
                          if (endDate && date && endDate < date) {
                            setEndDate(null);
                            dispatch(
                              showSnackbar(
                                "End Date must be later than the Start Date. Please select a valid End Date.",
                                "error"
                              )
                            );
                          }
                          setFieldValue(
                            `startContractDate`,
                            dayjs(date).format("YYYY-MM-DD")
                          );
                        }}
                        helperText={
                          <Typography
                            align="left"
                            // className="px-3"
                            color={ThemeColor.RED}
                            fontSize={fontSize.h4.medium}
                            fontFamily={FontFamily.Lato}
                            fontWeight={fontWeight.W500}
                          >
                            {errors.startContractDate}
                          </Typography>
                        }
                      />
                    </div>
                  </FormGroup>

                  <FormGroup style={{}}>
                    <div className="mt-4">
                      <OnlyDatePicker
                        views={["year", "month", "day"]}
                        label="End Contract Date"
                        // value={endDate}
                        value={
                          values.endContractDate
                            ? dayjs(values.endContractDate).isValid()
                              ? dayjs(values.endContractDate)
                              : null
                            : null
                        }
                        // value={dayjs(values.contacts[index].reminder_date).toDate()}
                        minDate={startDate}
                        onChange={(date) => {
                          setEndDate(date);
                          setFieldValue(
                            `endContractDate`,
                            dayjs(date).format("YYYY-MM-DD")
                          );
                        }}
                        helperText={
                          <Typography
                            align="left"
                            // className="px-3"
                            color={ThemeColor.RED}
                            fontSize={fontSize.h4.medium}
                            fontFamily={FontFamily.Lato}
                            fontWeight={fontWeight.W500}
                          >
                            {errors.endContractDate}
                          </Typography>
                        }
                      />
                    </div>
                  </FormGroup>

                  <FormGroup style={{}} className="mt-3">
                    <div className="">
                      <Typography
                        className=""
                        sx={{
                          fontWeight: 520,
                          fontSize: "0.9rem",
                          letterSpacing: "0.00938em",
                          fontFamily: "Lato !important",
                        }}
                      >
                        Notes
                      </Typography>
                      <OutlinedTextAreaField
                        multiline={true}
                        minRows={4}
                        value={values.notes}
                        name={"notes"}
                        onChange={handleChange}
                        placeholder="Enter Notes"
                        fullWidth={true}
                      />
                    </div>
                  </FormGroup>
                </Grid>

                {/* section for owner  */}
                <Grid item lg={12} sm={12} xs={12}>
                  <Typography
                    fontFamily={FontFamily.Poppins}
                    fontWeight={fontWeight.W600}
                    fontSize={fontSize.h3.medium}
                    color={ThemeColor.PURPLE}
                  >
                    Owner Details
                  </Typography>
                  <FieldArray name="owners">
                    {({ push, remove }) => (
                      <div>
                        {values?.owners?.map((contact, index) => (
                          <Grid container spacing={2} className="mt-4">
                            {index > 0 && (
                              <NoPaddingGridItem
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="d-flex align-items-center"
                              >
                                <div className="w-100 mt-2 mb-3">
                                  <Divider>
                                    <Chip
                                      label={`${index + 1} Owner Details `}
                                      size="small"
                                    />
                                  </Divider>
                                </div>
                              </NoPaddingGridItem>
                            )}
                            <NoPaddingGridItem
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <FormGroup style={{}}>
                                <div className="">
                                  <Typography
                                    className="mb-2"
                                    sx={{
                                      fontWeight: 520,
                                      fontSize: "0.9rem",
                                      letterSpacing: "0.00938em",
                                      fontFamily: "Lato !important",
                                    }}
                                  >
                                    Name of Owner (Admin) *
                                  </Typography>
                                  <OutlinedInputField
                                    value={values.owners[index].ownerName}
                                    name={`owners[${index}].ownerName`}
                                    onChange={handleChange}
                                    placeholder="Enter name"
                                    fullWidth={true}
                                    helperText={
                                      <Typography
                                        align="left"
                                        // className="px-3"
                                        color={ThemeColor.RED}
                                        fontSize={fontSize.h4.medium}
                                        fontFamily={FontFamily.Lato}
                                        fontWeight={fontWeight.W500}
                                      >
                                        {errors.owners?.[index]?.ownerName}
                                      </Typography>
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </NoPaddingGridItem>
                            <NoPaddingGridItem
                              item
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                            >
                              <FormGroup style={{}}>
                                <div className="">
                                  <Typography
                                    className="mb-2"
                                    sx={{
                                      fontWeight: 520,
                                      fontSize: "0.9rem",
                                      letterSpacing: "0.00938em",
                                      fontFamily: "Lato !important",
                                    }}
                                  >
                                    Email *
                                  </Typography>
                                  <OutlinedInputField
                                    value={values.owners[index].email}
                                    name={`owners[${index}].email`}
                                    onChange={handleChange}
                                    onBlur={async (e) => {
                                      handleBlur(e);
                                      if (!Edit && e.target.value) {
                                        try {
                                          const res = await CheckEmailExistService(e.target.value);
                                          if (res?.data?.exists) {
                                            setFieldError(
                                              `owners[${index}].email`,
                                              "User already exists with this email id"
                                            );
                                          }
                                        } catch (err) {
                                          console.error("Error checking email", err);
                                        }
                                      }
                                    }}
                                    disable={Edit ? true : false}
                                    placeholder="Enter your email...."
                                    fullWidth={true}
                                    helperText={
                                      <Typography
                                        align="left"
                                        // className="px-3"
                                        color={ThemeColor.RED}
                                        fontSize={fontSize.h4.medium}
                                        fontFamily={FontFamily.Lato}
                                        fontWeight={fontWeight.W500}
                                      >
                                        {errors.owners?.[index]?.email}
                                      </Typography>
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </NoPaddingGridItem>
                            <NoPaddingGridItem
                              item
                              lg={6}
                              md={6}
                              sm={12}
                              xs={12}
                            >
                              <FormGroup style={{}}>
                                <div className="">
                                  <Typography
                                    className="mb-2"
                                    sx={{
                                      fontWeight: 520,
                                      fontSize: "0.9rem",
                                      letterSpacing: "0.00938em",
                                      fontFamily: "Lato !important",
                                    }}
                                  >
                                    Phone *
                                  </Typography>
                                  <Grid container spacing={1}>
                                    <Grid item xs={4}>
                                      <CustomSelect
                                        value={parsePhoneNumber(values.owners[index].phone).countryCode}
                                        onChange={(e) => {
                                          const newCountryCode = e.target.value;
                                          const currentPhone = parsePhoneNumber(values.owners[index].phone);
                                          const mergedPhone = mergePhoneNumber(newCountryCode, currentPhone.number);
                                          setFieldValue(`owners[${index}].phone`, mergedPhone);
                                        }}
                                        displayEmpty
                                        option={countryCodes.map((cc) => ({ _id: cc.code, title: cc.code }))}
                                        label={"Country Code"}
                                      />
                                    </Grid>
                                    <Grid item xs={8}>
                                      <OutlinedInputField
                                        value={parsePhoneNumber(values.owners[index].phone).number}
                                        name={`owners[${index}].phone`}
                                        onChange={(e) => {
                                          const newNumber = e.target.value;
                                          const currentPhone = parsePhoneNumber(values.owners[index].phone);
                                          const mergedPhone = mergePhoneNumber(currentPhone.countryCode, newNumber);
                                          setFieldValue(`owners[${index}].phone`, mergedPhone);
                                        }}
                                        placeholder="Enter your phone...."
                                        fullWidth={true}
                                        helperText={
                                          <Typography
                                            align="left"
                                            // className="px-3"
                                            color={ThemeColor.RED}
                                            fontSize={fontSize.h4.medium}
                                            fontFamily={FontFamily.Lato}
                                            fontWeight={fontWeight.W500}
                                          >
                                            {errors.owners?.[index]?.phone}
                                          </Typography>
                                        }
                                      />
                                    </Grid>
                                  </Grid>
                                </div>
                              </FormGroup>
                            </NoPaddingGridItem>
                            <NoPaddingGridItem
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                            >
                              <FormGroup style={{}}>
                                <div className="mt-3">
                                  {/* <CustomSelect
                                    value={values?.owners[index]?.role}
                                    name={`owners[${index}].role`}
                                    option={Rolelist}
                                    onChange={(e) => {
                                      // //(e);
                                      setFieldValue(
                                        `owners[${index}].role`,
                                        e.target.value
                                      );
                                    }}
                                    label={"Role in organization"}
                                    fullWidth={true}
                                    helperText={
                                      <Typography
                                        align="left"
                                        // className="px-3"
                                        color={ThemeColor.RED}
                                        fontSize={fontSize.h4.medium}
                                        fontFamily={FontFamily.Lato}
                                        fontWeight={fontWeight.W500}
                                      >
                                        {errors.owners?.[index]?.role}
                                      </Typography>
                                    }
                                  /> */}
                                </div>
                              </FormGroup>
                            </NoPaddingGridItem>
                            {index > 0 && (
                              <NoPaddingGridItem
                                item
                                lg={3}
                                md={3}
                                sm={12}
                                xs={12}
                                className="d-flex align-items-center"
                              >
                                <div className="d-flex justify-content-start w-100 mt-3">
                                  <Typography
                                    className="px-2"
                                    fontSize={fontSize.h3.small}
                                    fontFamily={FontFamily.Lato}
                                    color={ThemeColor.BLACK}
                                    fontWeight={fontWeight.W600}
                                  >
                                    Delete Owner
                                  </Typography>
                                  <IconButton
                                    className="form-icon"
                                    sx={{
                                      background: ThemeColor.RED,
                                      color: ThemeColor.WHITE,
                                    }}
                                    variant="contained"
                                    onClick={() => remove(index)}
                                  >
                                    <RemoveIcon />
                                  </IconButton>
                                </div>
                              </NoPaddingGridItem>
                            )}
                          </Grid>
                        ))}
                        {!Edit && (
                          <div className="d-flex justify-content-end w-100 mt-3">
                            <Typography
                              className="px-2"
                              fontSize={fontSize.h3.medium}
                              fontFamily={FontFamily.Lato}
                              color={ThemeColor.BLACK}
                              fontWeight={fontWeight.W600}
                            >
                              Add More Owner
                            </Typography>
                            <IconButton
                              className="form-icon"
                              sx={{
                                background: ThemeColor.BLUE,
                                color: ThemeColor.WHITE,
                              }}
                              onClick={() =>
                                push({
                                  ownerName: "",
                                  email: "",
                                  phone: "",
                                  role: "",
                                })
                              }
                            >
                              <AddIcon />
                            </IconButton>
                          </div>
                        )}
                      </div>
                    )}
                  </FieldArray>
                </Grid>
                <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                  <FormGroup style={{}}>
                    <div className="">
                      <Typography
                        className="mb-2"
                        sx={{
                          fontWeight: 520,
                          fontSize: "0.9rem",
                          letterSpacing: "0.00938em",
                          fontFamily: "Lato !important",
                        }}
                      >
                        Assign To Organization *
                      </Typography>
                      {/* <MultiSelect
                        value={Organizationlist ? values.organizationIds : []}
                        onChange={(selectedOptions) =>
                          // setFieldValue(`organizationIds`, selectedOptions)
                          console.log(selectOptions)
                        }
                        name={"program"}
                        options={Universitylist}
                        // onChange={(e) => {
                        //   setFieldValue(
                        //     `commissionsAndPrograms[${index}].program`,
                        //     e.target.value
                        //   );
                        // }}
                        // label={"Program"}
                        fullWidth={true}
                        helperText={
                          <Typography
                            align="left"
                            // className="px-3"
                            color={ThemeColor.RED}
                            fontSize={fontSize.h4.medium}
                            fontFamily={FontFamily.Lato}
                            fontWeight={fontWeight.W500}
                          >
                            {errors.organizationIds}
                          </Typography>
                        }
                      /> */}
                    </div>
                  </FormGroup>
                </NoPaddingGridItem>
                {/* grid for bottom university list content */}
                {(window.sessionStorage.getItem("user_role_type") === "admin" ||
                  (window.sessionStorage.getItem("user_role_type") === "user" &&
                    window.sessionStorage.getItem("role") === "accountant") ||
                  (window.sessionStorage.getItem("user_role_type") ===
                    "agent" &&
                    window.sessionStorage.getItem("role") === "admin") ||
                  (window.sessionStorage.getItem("user_role_type") ===
                    "agent" &&
                    window.sessionStorage.getItem("role") ===
                    "agent_accountant")) && (
                    <Grid item lg={12} sm={12} xs={12}>
                      <Typography
                        fontFamily={FontFamily.Poppins}
                        fontWeight={fontWeight.W600}
                        fontSize={fontSize.h3.medium}
                        color={ThemeColor.PURPLE}
                      >
                        University List
                      </Typography>

                      <MultiSelect
                        value={selectedUnis || []}
                        onChange={(selected) => {
                          setSelectedUnis(selected);

                          const existing = values.universities || [];
                          const existingIds = existing.map((u) => u.university);

                          const newIds = selected.filter(
                            (id) => !existingIds.includes(id)
                          );

                          const newUnis = newIds.map((uniId) => {
                            const foundUniv = Universitylist?.find(univ => univ._id === uniId);
                            return {
                              university: uniId,
                              description: "",
                              // entries without a program can't be saved on the backend
                              commissionAndPrograms: foundUniv?.commissionsAndPrograms?.filter((data) => data.program?.length > 0)?.map((data) => ({
                                program: data.program.map((data) => {
                                  return data._id;
                                }),
                                degree: data.degree?._id,
                                commissionType: data.commissionType,
                                value: "80",
                                duration: data.duration,
                                customValue: Array.isArray(data.customValue) && data.customValue.length > 0 ? data.customValue : Array(Number(data.paymentCycle) || 0).fill(""),
                                paymentCycle: data.paymentCycle,
                                customAgentCommission: data.commissionType === 'C' ? (Array.isArray(data.customValue) ? data.customValue : []).map(v => ((Number(v) || 0) * 80) / 100) : Array(Number(data.paymentCycle) || 0).fill(""),
                                agentCommission: data.commissionType !== 'C' ? ((Number(data.value) || 0) * 80) / 100 : data.agentCommission,
                                termsAndCondition: data.termsAndConditionForOrg,
                              })) || [],
                            };
                          });

                          const updated = [
                            ...existing.filter((u) =>
                              selected.includes(u.university)
                            ),
                            ...newUnis,
                          ];

                          const sortedUpdated = updated.sort((a, b) => {
                            const nameA = Universitylist?.find((u) => u._id === a.university)?.title || "";
                            const nameB = Universitylist?.find((u) => u._id === b.university)?.title || "";
                            return nameA.localeCompare(nameB);
                          });

                          setFieldValue("universities", sortedUpdated);
                        }}
                        name={"universities"}
                        options={Universitylist || []}
                        fullWidth={true}
                        helperText={
                          <Typography
                            align="left"
                            color={ThemeColor.RED}
                            fontSize={fontSize.h4.medium}
                            fontFamily={FontFamily.Lato}
                            fontWeight={fontWeight.W500}
                          >
                            {errors.universities}
                          </Typography>
                        }
                      />
                      <FieldArray name="universities">
                        {({
                          push: pushUniversity,
                          remove: removeUniversity,
                          form,
                        }) => (
                          <div>
                            {values.universities.map((univ, univIndex) => (
                              <div
                                key={univIndex}
                                style={{ marginBottom: "20px" }}
                              >
                                <Accordion
                                  key={univIndex}
                                  defaultExpanded={false}
                                  TransitionProps={{ unmountOnExit: true }}
                                >
                                  <AccordionSummary expandIcon={<ExpandMore />}>
                                    <Typography fontWeight="bold">
                                      {Universitylist.filter(
                                        (univName) =>
                                          univName?._id === univ.university
                                      )?.[0]?.title ||
                                        `University ${univIndex + 1}`}
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <div>
                                      <CustomSelect
                                        name={`universities[${univIndex}].university`}
                                        fullWidth
                                        value={
                                          Universitylist
                                            ? values.universities[univIndex]
                                              .university
                                            : ""
                                        }
                                        option={Universitylist}
                                        multiple={false}
                                        disabled={true}
                                        onChange={(e) => {
                                          const selectedUniversity =
                                            e.target.value;
                                          setFieldValue(
                                            `universities[${univIndex}].university`,
                                            selectedUniversity
                                          );
                                          setFieldValue(
                                            `universities[${univIndex}].description`,
                                            Universitylist?.filter(
                                              (univ) =>
                                                univ._id === selectedUniversity
                                            )?.[0]?.description
                                          );

                                          // Prefill the program names
                                          setFieldValue(
                                            `universities[${univIndex}].commissionAndPrograms`,
                                            Universitylist?.filter(
                                              (univ) =>
                                                univ._id === selectedUniversity
                                            )?.[0]?.commissionsAndPrograms?.filter(
                                              (data) => data.program?.length > 0
                                            )?.map(
                                              (data) => ({
                                                program: data.program.map(
                                                  (data) => {
                                                    return data._id;
                                                  }
                                                ),
                                                degree: data.degree?._id,
                                                commissionType:
                                                  data.commissionType,
                                                value: data.value || "80",
                                                duration: data.duration,
                                                customValue: Array.isArray(data.customValue) && data.customValue.length > 0 ? data.customValue : Array(Number(data.paymentCycle) || 0).fill(""),
                                                paymentCycle: data.paymentCycle,
                                                customAgentCommission: data.commissionType === 'C' ? (Array.isArray(data.customValue) ? data.customValue : []).map(v => ((Number(v) || 0) * 80) / 100) : Array(Number(data.paymentCycle) || 0).fill(""),
                                                agentCommission: data.commissionType !== 'C' ? ((Number(data.value) || 0) * 80) / 100 : data.agentCommission,
                                                termsAndCondition:
                                                  data.termsAndConditionForOrg,
                                              })
                                            ) || []
                                          );
                                        }}
                                      ></CustomSelect>
                                    </div>

                                    {/* Nested FieldArray for Commission Programs */}
                                    <FieldArray
                                      name={`universities[${univIndex}].commissionAndPrograms`}
                                    >
                                      {({
                                        push: pushCommission,
                                        remove: removeCommission,
                                      }) => (
                                        <div style={{ marginTop: "10px" }}>
                                          {univ?.commissionAndPrograms?.map(
                                            (comm, commIndex) => (
                                              <Grid
                                                key={commIndex}
                                                container
                                                spacing={2}
                                              >
                                                {commIndex > 0 && (
                                                  <NoPaddingGridItem
                                                    item
                                                    lg={12}
                                                    md={12}
                                                    sm={12}
                                                    xs={12}
                                                    className="d-flex align-items-center"
                                                  >
                                                    <div className="w-100 mt-2 mb-3">
                                                      <Divider>
                                                        <Chip
                                                          label={`${commIndex + 1
                                                            } Commison and program details `}
                                                          size="small"
                                                        />
                                                      </Divider>
                                                    </div>
                                                  </NoPaddingGridItem>
                                                )}

                                                {/* The per-university Description field was
                                                    removed: it was read-only and no code path
                                                    ever filled it, so it only ever showed a
                                                    placeholder. `universities[].description`
                                                    still exists on the model and in the
                                                    payload; nothing else changed. */}
                                                <NoPaddingGridItem
                                                  item
                                                  lg={4}
                                                  md={4}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <FormGroup style={{}}>
                                                    <Typography
                                                      className="mb-1"
                                                      sx={{
                                                        fontWeight: 520,
                                                        fontSize: "0.9rem",
                                                        letterSpacing:
                                                          "0.00938em",
                                                        fontFamily:
                                                          "Lato !important",
                                                      }}
                                                    >
                                                      Degree Type
                                                    </Typography>
                                                    <div className="">
                                                      <CustomSelect
                                                        disabled={true}
                                                        value={
                                                          Degreelist
                                                            ? values.universities[
                                                              univIndex
                                                            ]
                                                              .commissionAndPrograms[
                                                              commIndex
                                                            ]?.degree
                                                            : ""
                                                        }
                                                        name={`universities[${univIndex}].commissionAndPrograms[${commIndex}].degreeType`}
                                                        multiple={false}
                                                        option={Degreelist}
                                                        onChange={(e) =>
                                                          setFieldValue(
                                                            `universities[${univIndex}].commissionAndPrograms[${commIndex}].degreeType`,
                                                            e.target.value
                                                          )
                                                        }
                                                        fullWidth={true}
                                                        label={"Degree"}
                                                      />
                                                    </div>
                                                  </FormGroup>
                                                </NoPaddingGridItem>
                                                <NoPaddingGridItem
                                                  item
                                                  lg={4}
                                                  md={4}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <FormGroup style={{}}>
                                                    <div className="w-100">
                                                      <Typography
                                                        className="mb-1"
                                                        sx={{
                                                          fontWeight: 520,
                                                          fontSize: "0.9rem",
                                                          letterSpacing:
                                                            "0.00938em",
                                                          fontFamily:
                                                            "Lato !important",
                                                        }}
                                                      >
                                                        Program
                                                      </Typography>
                                                      <CustomSelect
                                                        disabled={true}
                                                        value={
                                                          Programlist
                                                            ? values.universities[
                                                              univIndex
                                                            ]
                                                              .commissionAndPrograms[
                                                              commIndex
                                                            ]?.program
                                                            : []
                                                        }
                                                        name={`universities[${univIndex}].commissionAndPrograms[${commIndex}].program`}
                                                        multiple={true}
                                                        option={Programlist}
                                                        onChange={(e) => {
                                                          setFieldValue(
                                                            `universities[${univIndex}].commissionAndPrograms[${commIndex}].program`,
                                                            e.target.value
                                                          );
                                                        }}
                                                        label={"Program"}
                                                        fullWidth={true}
                                                      />
                                                    </div>
                                                  </FormGroup>
                                                </NoPaddingGridItem>

                                                <NoPaddingGridItem
                                                  item
                                                  lg={4}
                                                  md={4}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <FormGroup style={{}}>
                                                    <div className="">
                                                      <Typography
                                                        className="mb-1"
                                                        sx={{
                                                          fontWeight: 520,
                                                          fontSize: "0.9rem",
                                                          letterSpacing:
                                                            "0.00938em",
                                                          fontFamily:
                                                            "Lato !important",
                                                        }}
                                                      >
                                                        Commision Type
                                                      </Typography>
                                                      <CustomSelect
                                                        // disabled={
                                                        //   window.sessionStorage.getItem(
                                                        //     "user_role_type"
                                                        //   ) === "agent" &&
                                                        //   window.sessionStorage.getItem(
                                                        //     "role"
                                                        //   ) === "admin"
                                                        // }
                                                        disabled={true}
                                                        value={
                                                          values.universities[
                                                            univIndex
                                                          ].commissionAndPrograms[
                                                            commIndex
                                                          ].commissionType
                                                        }
                                                        name={`universities[${univIndex}].commissionAndPrograms[${commIndex}].commissionType`}
                                                        multiple={false}
                                                        option={[
                                                          {
                                                            _id: "F",
                                                            title: "Fixed",
                                                          },
                                                          {
                                                            _id: "P",
                                                            title: "Percentage",
                                                          },
                                                          {
                                                            _id: "C",
                                                            title: "Custom",
                                                          },
                                                          {
                                                            _id: "S",
                                                            title: "Scholarship",
                                                          },
                                                        ]}
                                                        onChange={(e) => {
                                                          const selectedType = e.target.value;
                                                          setFieldValue(
                                                            `universities[${univIndex}].commissionAndPrograms[${commIndex}].commissionType`,
                                                            selectedType
                                                          );
                                                          if (selectedType === "S") {
                                                            setFieldValue(
                                                              `universities[${univIndex}].commissionAndPrograms[${commIndex}].value`,
                                                              0
                                                            );
                                                          }
                                                        }}
                                                        label={"Commission Type"}
                                                        fullWidth={true}
                                                      />
                                                    </div>
                                                  </FormGroup>
                                                </NoPaddingGridItem>

                                                <NoPaddingGridItem
                                                  item
                                                  lg={4}
                                                  md={4}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <FormGroup style={{}}>
                                                    <div className="">
                                                      <Typography
                                                        className="mb-2"
                                                        sx={{
                                                          fontWeight: 520,
                                                          fontSize: "0.9rem",
                                                          letterSpacing:
                                                            "0.00938em",
                                                          fontFamily:
                                                            "Lato !important",
                                                        }}
                                                      >
                                                        Value
                                                      </Typography>
                                                      <div className="d-flex align-item-center">
                                                        <OutlinedInputField
                                                          disable={
                                                            (window.sessionStorage.getItem(
                                                              "user_role_type"
                                                            ) === "agent" &&
                                                              window.sessionStorage.getItem(
                                                                "role"
                                                              ) === "admin") ||
                                                            values.universities[
                                                              univIndex
                                                            ]?.commissionAndPrograms[
                                                              commIndex
                                                            ]?.commissionType === "S"
                                                          }
                                                          defaultValue="80"
                                                          value={
                                                            values.universities[
                                                              univIndex
                                                            ]
                                                              .commissionAndPrograms[
                                                              commIndex
                                                            ].value
                                                          }
                                                          name={`universities[${univIndex}].commissionAndPrograms[${commIndex}].value`}
                                                          onChange={(e) => {
                                                            handleChange(e);
                                                            const newValue = e.target.value;
                                                            const selectedUniv = Universitylist?.find(u => u._id === values.universities[univIndex].university);
                                                            const univCommData = selectedUniv?.commissionsAndPrograms?.[commIndex];
                                                            
                                                            if (univCommData) {
                                                                if (values.universities[univIndex].commissionAndPrograms[commIndex].commissionType === 'C') {
                                                                   const newCustomAgentComm = (univCommData.customValue || []).map(val => ((Number(val) || 0) * Number(newValue)) / 100);
                                                                   setFieldValue(`universities[${univIndex}].commissionAndPrograms[${commIndex}].customAgentCommission`, newCustomAgentComm);
                                                                } else {
                                                                   const univValue = univCommData.value || 0;
                                                                   const calculatedCommission = ((Number(univValue) || 0) * Number(newValue)) / 100;
                                                                   setFieldValue(`universities[${univIndex}].commissionAndPrograms[${commIndex}].agentCommission`, calculatedCommission);
                                                                }
                                                            }
                                                          }}
                                                          placeholder="Enter your details...."
                                                          fullWidth={true}
                                                        />
                                                        <Typography
                                                          className="px-2 py-2"
                                                          sx={{
                                                            fontSize:
                                                              fontSize.h3.large,
                                                            fontWeight:
                                                              fontWeight.W600,
                                                          }}
                                                        >
                                                          {/* {values.universities[
                                                          univIndex
                                                        ].commissionAndPrograms[
                                                          commIndex
                                                        ].commissionType === "P"
                                                          ? "%"
                                                          : "$"}"%" */}
                                                          %
                                                        </Typography>
                                                      </div>
                                                    </div>
                                                  </FormGroup>
                                                </NoPaddingGridItem>

                                                {values.universities[univIndex]
                                                  .commissionAndPrograms[
                                                  commIndex
                                                ].commissionType === "C" && false &&
                                                  Array.from({
                                                    length:
                                                      Number(
                                                        values.universities[
                                                          univIndex
                                                        ].commissionAndPrograms[
                                                          commIndex
                                                        ].paymentCycle
                                                      ) || 0,
                                                  }).map((_, cycleIndex) => (
                                                    <NoPaddingGridItem
                                                      key={cycleIndex}
                                                      item
                                                      lg={4}
                                                      md={4}
                                                      sm={12}
                                                      xs={12}
                                                    >
                                                      <FormGroup>
                                                        <div>
                                                          <Typography
                                                            className="mb-2"
                                                            fontFamily={
                                                              FontFamily.Lato
                                                            }
                                                            fontSize={
                                                              fontSize.h3.medium
                                                            }
                                                            fontWeight={
                                                              fontWeight.W400
                                                            }
                                                          >
                                                            Custom Value{" "}
                                                            {cycleIndex + 1}
                                                          </Typography>

                                                          <OutlinedInputField
                                                            type={"text"}
                                                            value={
                                                              values.universities[
                                                                univIndex
                                                              ]
                                                                .commissionAndPrograms[
                                                                commIndex
                                                              ].customValue?.[
                                                              cycleIndex
                                                              ] || ""
                                                            }
                                                            name={`universities[${univIndex}].commissionAndPrograms[${commIndex}].customValue[${cycleIndex}]`}
                                                            onChange={
                                                              handleChange
                                                            }
                                                            placeholder={`Enter custom value for cycle ${cycleIndex + 1
                                                              }`}
                                                            fullWidth
                                                            helperText={
                                                              <Typography
                                                                align="left"
                                                                color={
                                                                  ThemeColor.RED
                                                                }
                                                                fontSize={
                                                                  fontSize.h4
                                                                    .medium
                                                                }
                                                                fontFamily={
                                                                  FontFamily.Lato
                                                                }
                                                                fontWeight={
                                                                  fontWeight.W500
                                                                }
                                                              >
                                                                {/* {
                                                                errors
                                                                  .commissionsAndPrograms?.[
                                                                  index
                                                                ]
                                                                  ?.customValue?.[
                                                                  cycleIndex
                                                                ]
                                                              } */}
                                                              </Typography>
                                                            }
                                                          />
                                                        </div>
                                                      </FormGroup>
                                                    </NoPaddingGridItem>
                                                  ))}

                                                {values.universities[univIndex]
                                                  .commissionAndPrograms[
                                                  commIndex
                                                ].commissionType !== "C" && (
                                                    <NoPaddingGridItem
                                                      item
                                                      lg={4}
                                                      md={4}
                                                      sm={12}
                                                      xs={12}
                                                    >
                                                      <FormGroup style={{}}>
                                                        <div className="">
                                                          <Typography
                                                            className="mb-2"
                                                            sx={{
                                                              fontWeight: 520,
                                                              fontSize: "0.9rem",
                                                              letterSpacing:
                                                                "0.00938em",
                                                              fontFamily:
                                                                "Lato !important",
                                                            }}
                                                          >
                                                            Total Agent Commission
                                                          </Typography>
                                                          <div className="d-flex">
                                                            <OutlinedInputField
                                                              disable={true}
                                                              value={
                                                                values.universities[
                                                                  univIndex
                                                                ]
                                                                  .commissionAndPrograms[
                                                                  commIndex
                                                                ].agentCommission
                                                              }
                                                              name={`universities[${univIndex}].commissionAndPrograms[${commIndex}].agentCommission`}
                                                              onChange={
                                                                handleChange
                                                              }
                                                              placeholder="Enter your agent commission details...."
                                                              fullWidth={true}
                                                            />
                                                            <Typography
                                                              className="px-2"
                                                              sx={{
                                                                fontSize:
                                                                  fontSize.h3.large,
                                                                fontWeight:
                                                                  fontWeight.W600,
                                                              }}
                                                            >
                                                              {values.universities[univIndex].commissionAndPrograms[commIndex].commissionType === "P" ? "%" : "$"}
                                                            </Typography>
                                                          </div>
                                                        </div>
                                                      </FormGroup>
                                                    </NoPaddingGridItem>
                                                  )}

                                                {values.universities[univIndex]
                                                  .commissionAndPrograms[
                                                  commIndex
                                                ].commissionType === "C" &&
                                                  Array.from({
                                                    length:
                                                      Number(
                                                        values.universities[
                                                          univIndex
                                                        ].commissionAndPrograms[
                                                          commIndex
                                                        ].customAgentCommission
                                                          ?.length
                                                      ) || 0,
                                                  }).map((_, cycleIndex) => (
                                                    <NoPaddingGridItem
                                                      key={cycleIndex}
                                                      item
                                                      lg={4}
                                                      md={4}
                                                      sm={12}
                                                      xs={12}
                                                    >
                                                      <FormGroup>
                                                        <div>
                                                          <Typography
                                                            className="mb-2"
                                                            fontFamily={
                                                              FontFamily.Lato
                                                            }
                                                            fontSize={
                                                              fontSize.h3.medium
                                                            }
                                                            fontWeight={
                                                              fontWeight.W400
                                                            }
                                                          >
                                                            Custom Agent
                                                            Commission{" "}
                                                            {cycleIndex + 1}
                                                          </Typography>
                                                          <div className="d-flex">
                                                            <OutlinedInputField
                                                              disable={true}
                                                              type={"number"}
                                                              value={
                                                                values
                                                                  .universities[
                                                                  univIndex
                                                                ]
                                                                  .commissionAndPrograms[
                                                                  commIndex
                                                                ]
                                                                  .customAgentCommission?.[
                                                                cycleIndex
                                                                ] || ""
                                                              }
                                                              name={`universities[${univIndex}].commissionAndPrograms[${commIndex}].customAgentCommission[${cycleIndex}]`}
                                                              onChange={
                                                                handleChange
                                                              }
                                                              placeholder={`Enter custom value for cycle ${cycleIndex + 1
                                                                }`}
                                                              fullWidth
                                                              helperText={
                                                                <Typography
                                                                  align="left"
                                                                  color={
                                                                    ThemeColor.RED
                                                                  }
                                                                  fontSize={
                                                                    fontSize.h4
                                                                      .medium
                                                                  }
                                                                  fontFamily={
                                                                    FontFamily.Lato
                                                                  }
                                                                  fontWeight={
                                                                    fontWeight.W500
                                                                  }
                                                                >
                                                                  {/* {
                                                            errors
                                                              .commissionsAndPrograms?.[
                                                              index
                                                            ]
                                                              ?.customValue?.[
                                                              cycleIndex
                                                            ]
                                                          } */}
                                                                </Typography>
                                                              }
                                                            />
                                                            <Typography
                                                              className="px-2"
                                                              sx={{
                                                                fontSize:
                                                                  fontSize.h3
                                                                    .large,
                                                                fontWeight:
                                                                  fontWeight.W600,
                                                              }}
                                                            >
                                                              $
                                                            </Typography>
                                                          </div>
                                                        </div>
                                                      </FormGroup>
                                                    </NoPaddingGridItem>
                                                  ))}

                                                <NoPaddingGridItem
                                                  item
                                                  lg={4}
                                                  md={4}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <FormGroup style={{}}>
                                                    <div className="">
                                                      <Typography
                                                        className="mb-1"
                                                        sx={{
                                                          fontWeight: 520,
                                                          fontSize: "0.9rem",
                                                          letterSpacing:
                                                            "0.00938em",
                                                          fontFamily:
                                                            "Lato !important",
                                                        }}
                                                      >
                                                        Duration
                                                      </Typography>
                                                      <CustomSelect
                                                        disabled={true}
                                                        value={
                                                          values.universities[
                                                            univIndex
                                                          ].commissionAndPrograms[
                                                            commIndex
                                                          ].duration
                                                        }
                                                        name={`universities[${univIndex}].commissionAndPrograms[${commIndex}].duration`}
                                                        multiple={false}
                                                        option={[
                                                          {
                                                            _id: "S",
                                                            title:
                                                              "Semester-wise",
                                                          },
                                                          {
                                                            _id: "Y",
                                                            title: "Year-wise",
                                                          },
                                                        ]}
                                                        onChange={(e) => {
                                                          setFieldValue(
                                                            `universities[${univIndex}].commissionAndPrograms[${commIndex}].duration`,
                                                            e.target.value
                                                          );
                                                        }}
                                                        label={"Duration"}
                                                        fullWidth={true}
                                                      />
                                                    </div>
                                                  </FormGroup>
                                                </NoPaddingGridItem>

                                                <NoPaddingGridItem
                                                  item
                                                  lg={4}
                                                  md={4}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <FormGroup style={{}}>
                                                    <div className="">
                                                      <Typography
                                                        className="mb-2"
                                                        sx={{
                                                          fontWeight: 520,
                                                          fontSize: "0.9rem",
                                                          letterSpacing:
                                                            "0.00938em",
                                                          fontFamily:
                                                            "Lato !important",
                                                        }}
                                                      >
                                                        Payment Cycle
                                                      </Typography>
                                                      <OutlinedInputField
                                                        disable={true}
                                                        value={
                                                          values.universities[
                                                            univIndex
                                                          ].commissionAndPrograms[
                                                            commIndex
                                                          ].paymentCycle
                                                        }
                                                        name={`universities[${univIndex}].commissionAndPrograms[${commIndex}].paymentCycle`}
                                                        onChange={handleChange}
                                                        placeholder="Enter your payment cycle details...."
                                                        fullWidth={true}
                                                      />
                                                    </div>
                                                  </FormGroup>
                                                </NoPaddingGridItem>
                                                <NoPaddingGridItem
                                                  item
                                                  lg={4}
                                                  md={4}
                                                  sm={12}
                                                  xs={12}
                                                >
                                                  <FormGroup style={{}}>
                                                    <div className="">
                                                      <Typography
                                                        className="mb-2"
                                                        sx={{
                                                          fontWeight: 520,
                                                          fontSize: "0.9rem",
                                                          letterSpacing:
                                                            "0.00938em",
                                                          fontFamily:
                                                            "Lato !important",
                                                        }}
                                                      >
                                                        Terms And Condition
                                                      </Typography>
                                                      {/* <OutlinedInputField
                                                      disable={
                                                        window.sessionStorage.getItem(
                                                          "user_role_type"
                                                        ) === "agent" &&
                                                        window.sessionStorage.getItem(
                                                          "role"
                                                        ) === "admin"
                                                      }
                                                      value={
                                                        values.universities[
                                                          univIndex
                                                        ].commissionAndPrograms[
                                                          commIndex
                                                        ].termsAndCondition
                                                      }
                                                      name={`universities[${univIndex}].commissionAndPrograms[${commIndex}].termsAndCondition`}
                                                      onChange={handleChange}
                                                      placeholder="Enter your terms and condition details...."
                                                      fullWidth={true}
                                                    /> */}
                                                      <OutlinedTextAreaField
                                                        disabled={
                                                          window.sessionStorage.getItem(
                                                            "user_role_type"
                                                          ) === "agent" &&
                                                          window.sessionStorage.getItem(
                                                            "role"
                                                          ) === "admin"
                                                        }
                                                        value={
                                                          values.universities[
                                                            univIndex
                                                          ].commissionAndPrograms[
                                                            commIndex
                                                          ].termsAndCondition
                                                        }
                                                        name={`universities[${univIndex}].commissionAndPrograms[${commIndex}].termsAndCondition`}
                                                        onChange={handleChange}
                                                        placeholder="Enter your terms and condition details...."
                                                        fullWidth={true}
                                                      />
                                                    </div>
                                                  </FormGroup>
                                                </NoPaddingGridItem>
                                              </Grid>
                                            )
                                          )}
                                        </div>
                                      )}
                                    </FieldArray>
                                    <div className="d-flex justify-content-start w-100 mt-3 mb-3">
                                      <Typography
                                        className="px-2"
                                        fontSize={fontSize.h3.small}
                                        fontFamily={FontFamily.Lato}
                                        color={ThemeColor.BLACK}
                                        fontWeight={fontWeight.W600}
                                      >
                                        Delete {univIndex} University
                                      </Typography>
                                      <IconButton
                                        className="form-icon"
                                        sx={{
                                          background: ThemeColor.RED,
                                          color: ThemeColor.WHITE,
                                        }}
                                        variant="contained"
                                        onClick={() =>
                                          removeUniversity(univIndex)
                                        }
                                      >
                                        <RemoveIcon />
                                      </IconButton>
                                    </div>
                                  </AccordionDetails>
                                </Accordion>
                              </div>
                            ))}

                            <Button
                              type="button"
                              onClick={() =>
                                pushUniversity({
                                  university: "",
                                  commissions: [
                                    {
                                      degreeType: "",
                                      program: [],
                                      commissionType: "",
                                      value: "",
                                      duration: "",
                                      paymentCycle: "",
                                      customAgentCommission: [],
                                      termsAndCondition: "",
                                      description: "",
                                      agentCommission: "",
                                    },
                                  ],
                                })
                              }
                            >
                              Add University
                            </Button>
                          </div>
                        )}
                      </FieldArray>
                    </Grid>
                  )}
              </Grid>

              {/* <FieldArray name="universities">
                {({ push, remove }) =>
                  values.universities?.map((uni, i) => (
                    <div
                      key={i}
                      style={{
                        margin: "20px",
                        padding: "10px",
                        border: "1px solid gray",
                      }}
                    >
                      <h4>{selectedUnis[i]?.label}</h4>
                      <Field
                        name={`universities[${i}].description`}
                        placeholder="Description"
                        as={TextField}
                        fullWidth
                      />

                      <FieldArray
                        name={`universities[${i}].commissionAndPrograms`}
                      >
                        {({ push, remove }) =>
                          uni.commissionAndPrograms?.map((c, j) => (
                            <div key={j} style={{ marginTop: "10px" }}>
                              <Field
                                name={`universities[${i}].commissionAndPrograms[${j}].degree`}
                                placeholder="Degree"
                                as={TextField}
                                fullWidth
                              />
                              <Field
                                name={`universities[${i}].commissionAndPrograms[${j}].program[0]`}
                                placeholder="Program"
                                as={TextField}
                                fullWidth
                              />
                              <Field
                                name={`universities[${i}].commissionAndPrograms[${j}].commissionType`}
                                placeholder="Commission Type"
                                as={TextField}
                                fullWidth
                              />
                              <Field
                                name={`universities[${i}].commissionAndPrograms[${j}].value`}
                                placeholder="Value"
                                type="number"
                                as={TextField}
                                fullWidth
                              />
                              <Field
                                name={`universities[${i}].commissionAndPrograms[${j}].duration`}
                                placeholder="Duration"
                                as={TextField}
                                fullWidth
                              />
                              <Field
                                name={`universities[${i}].commissionAndPrograms[${j}].paymentCycle`}
                                placeholder="Payment Cycle"
                                type="number"
                                as={TextField}
                                fullWidth
                              />
                              <Field
                                name={`universities[${i}].commissionAndPrograms[${j}].termsAndCondition`}
                                placeholder="Terms and Conditions"
                                as={TextField}
                                fullWidth
                              />

                              <Button onClick={() => remove(j)}>
                                Remove Program
                              </Button>
                            </div>
                          ))
                        }
                        <Button
                          onClick={() =>
                            push({
                              degree: "",
                              program: [""],
                              commissionType: "",
                              value: "",
                              duration: "",
                              paymentCycle: "",
                              termsAndCondition: "",
                            })
                          }
                        >
                          Add Program
                        </Button>
                      </FieldArray>
                    </div>
                  ))
                }
              </FieldArray> */}

            </div>
          </Form>
        )}
      </Formik>
    );
  };

function CreateOrganization() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<CreateOrganizationPage />} />
    </div>
  );
}

export default CreateOrganization;
